import { createSlice } from '@reduxjs/toolkit'
import { Sensor } from '../../types'

interface SensorState {
  sensors: Sensor[]
  sensor: Sensor | undefined
}

export interface SensorData {
  latest: Sensor
}

const initialState: SensorState = {
  sensors: [],
  sensor: undefined
}

const sensorSlice = createSlice({
  name: 'sensors',
  initialState,
  reducers: {
    setSensors(state, action) {
      state.sensors = action.payload
    },
    setSensor(state, action) {
      state.sensor = action.payload
    }
  }
})

export const { setSensors, setSensor } = sensorSlice.actions

export default sensorSlice.reducer
